import { render, staticRenderFns } from "./StockInquiry.vue?vue&type=template&id=5a69a751&"
import script from "./StockInquiry.vue?vue&type=script&lang=js&"
export * from "./StockInquiry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports